import { useState, useEffect } from 'react'
import moment from 'moment-timezone'
import Panel from './panel'
import Accordion from './accordion'
import './App.scss'

// const studio = {
//   content: [
//   <article key="studio" className="panel--studio">
//     <p>Assemblage Studio partners with individuals, businesses and organizations to authentically articulate and realize their commitments to responsible practices through design and business development.</p>
//   </article>],
//   color: '#E57845'
// }
const contact = {
  content: [
    <div key="contact" className="panel--contact">
      <div>
        <p>For all project enquiries:</p>
        <p><a href="mailto:home@assemblageworld.com" title="Email">home@assemblageworld.com</a></p>
      </div>
      <span>&copy; Assemblage World Ltd., {(new Date().getFullYear())}</span>
    </div>
  ],
  color: '#0079A3'
}
const about = {
  content: [
    <div key="about" className="panel--about">
      <div>
        <p>Assemblage Studio is a consultancy. We strategically connect brand vision with long-lasting commercial opportunities, collectively benefiting stakeholders, customers and collaborative communities.</p>
        <p>As advocates for brand integrity, our experience in consumer goods and services empowers us to cross pollinate proven and innovative methodologies in the fashion, design, hospitality and publishing industries.</p>
        <p>Through storytelling content, visual presentation and global business development, our partnerships span brands and retailers, designers and business owners, mills and manufacturers and international commercial offices.</p>
      </div>
      <Accordion>
        <article label="Founding Team">
          <div>
            <h3>Marisa Ma</h3>
            <p>Marisa strives for a paradigm shift of responsible practices through renewed standards of what it is to be a conscience-led brand and the operation of them.</p>
            <p>Her professional experience began in entertainment  PR and communications in New York City and continued in journalism for bi-lingual publications in Italy. During this period, she delved into business development for fashion and lifestyle projects. Fifteen years later, she co-founded Atelier &amp; Repairs, a fully vertical business model based on principles of the circular economy. Marisa has contributed to various sustainability focused publications including The Ellen MacArthur Foundation's Make Fashion Circular case studies.</p>
            <p>Born in Hong Kong, Marisa spent her formative years in California before studying at New York University. She currently lives in Los Angeles with her husband and son.</p>
          </div>
          <div>
            <h3>Kate Montana</h3>
            <p>Kate is driven by a mission to bring positive, holistic, and sustainable change to our production and consumption habits through inspiring open information and knowledge exchange.</p>
            <p>With experience in hospitality and lifestyle copywriting and retail marketing and activations, Kate joined the founding team of Atelier &amp; Repairs in 2015 focusing on the brand narrative while driving the company's commercial reach to key global retailers and partners.</p>
            <p>Kate was born in California and earned a BA in Global Communications with a concentration in Writing for the Media from the American University of Rome, followed by projects in Spain and New York City. She currently lives in Los Angeles.</p>
          </div>
        </article>
      </Accordion>
    </div>
  ],
  color: '#F7CA46'
}

const hours = moment().tz("America/Los_Angeles").format("HH")
const mins = moment().tz("America/Los_Angeles").format("mm")

function App() {
  const [content, setContent] = useState('')
  const [panelOpen, setPanelOpen] = useState(false)
  const [height, setHeight] = useState(window.innerHeight)

  function closePanel() {
    setPanelOpen(false)
  }

  function updateWindowDimensions() {
    setHeight(window.innerHeight)
  }

  useEffect(() => {
    updateWindowDimensions()
    window.addEventListener('resize', updateWindowDimensions)
  }, [])

  return (
    <>
      <div
        style={{height: height + 'px'}} 
        className="grid">
        <header className="header">
          <div className="logo">
            <svg xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 2000 156">
              <path d="M527,89.8h67.5v-26.2h-67.5V29.8h72.4V3.4h-103.2v149.3h105.1v-26.4h-74.2v-36.5ZM403.3,62.1c-23.5-5.9-32.5-9.6-32.5-21.2s9.2-16.4,22.9-16.4,26,9,26,24.5h31.3c0-32.1-19.3-49.1-56.6-49.1s-55.2,18-55.2,44.3,25.6,39.4,53.7,46.6c21.2,5.5,30.8,8,30.8,21.2s-10.1,19.1-25.8,19.1-28.9-9.4-28.9-27.5h-31.9c0,34,23.3,52.4,60.4,52.4s58.3-18.9,58.3-47.2-24.3-39.8-52.4-46.8ZM1916.9,63.7h12.5V3.3h-12.5v60.4ZM749.8,71.9c-5.7,18-10.7,36.7-14.7,55h-.4c-4-18.2-9-36.9-14.7-55l-21.6-68.6h-49.5v149.3h29.6v-74.2c0-18.7-.4-37.3-1.3-56h.4c4.8,18.2,10.3,36.9,15.9,55l23.7,75.3h35.2l23.7-75.3c5.7-18,11.1-36.7,15.9-55h.4c-.8,18.7-1.3,37.3-1.3,56v74.2h29.6V3.4h-49.5l-21.6,68.6ZM1971.4,1.9c-17.7,0-28.6,12-28.6,31.6s10.9,31.6,28.6,31.6,28.6-12,28.6-31.6-10.9-31.6-28.6-31.6ZM1971.4,54c-9.8,0-15.7-7.8-15.7-20.5s5.9-20.5,15.7-20.5,15.7,7.8,15.7,20.5-5.9,20.5-15.7,20.5ZM51.8,3.4L0,152.7h32.3l11.7-36.5h57.3l11.5,36.5h32.3L93.3,3.4h-41.5ZM52.4,89.8l3.1-9.9c6.1-19.3,11.7-39,16.8-58.3h.4c5,19.3,10.9,39,17,58.3l3.1,9.9h-40.5ZM242.9,62.1c-23.5-5.9-32.5-9.6-32.5-21.2s9.2-16.4,22.9-16.4,26,9,26,24.5h31.3c0-32.1-19.3-49.1-56.6-49.1s-55.2,18-55.2,44.3,25.6,39.4,53.7,46.6c21.2,5.5,30.8,8,30.8,21.2s-10.1,19.1-25.8,19.1-28.9-9.4-28.9-27.5h-31.9c0,34,23.3,52.4,60.4,52.4s58.3-18.9,58.3-47.2-24.3-39.8-52.4-46.8ZM953,77v-.4c17.4-6.5,26-17.6,26-34.8s-17.2-38.4-54.3-38.4h-53.7v149.3h58.3c33.6,0,53.3-15.9,53.3-40.9s-9.2-30.4-29.6-34.8ZM901.8,28.5h23.3c17,0,24.3,5.5,24.3,17.8s-7.8,18.5-25.8,18.5h-21.8V28.5ZM924.7,127.3h-22.9v-38.2h22c19.7,0,27.5,6.1,27.5,19.5s-7.6,18.7-26.6,18.7ZM1701.3,27c-9.5-2.4-13.2-3.9-13.2-8.6s3.7-6.6,9.2-6.6,10.5,3.6,10.5,9.9h12.6c0-13-7.8-19.9-22.9-19.9s-22.3,7.3-22.3,17.9,10.4,16,21.7,18.8c8.6,2.2,12.5,3.2,12.5,8.6s-4.1,7.7-10.4,7.7-11.7-3.8-11.7-11.1h-12.9c0,13.7,9.4,21.2,24.4,21.2s23.6-7.6,23.6-19.1-9.8-16.1-21.2-18.9ZM1543.6,89.8h67.5v-26.2h-67.5V29.8h72.4V3.4h-103.2v149.3h105.1v-26.4h-74.2v-36.5ZM1727.9,13.9h19v49.7h12.5V13.9h19V3.3h-50.5v10.7ZM1402.4,27.2c16.5,0,26.4,8.1,29.2,22.7h33c-3-30.4-25.5-49.9-62.2-49.9s-71,29.8-71,78.7,26.4,77,75,77,43.1-4.5,58.1-11.6v-73.1h-64.7v24.9h33.7v32.2c-4.5,1.7-14.1,3.4-23.2,3.4-32.2,0-47.2-19.9-47.2-52.7s15.2-51.4,39.2-51.4ZM1058.1,3.4h-30.8v149.3h101.3v-26.4h-70.5V3.4ZM1823.6,40.2c0,9-4.1,13.8-11.5,13.8s-11.5-4.8-11.5-13.8V3.3h-12.5v37.3c0,16,8.7,24.4,24,24.4s24-8.5,24-24.4V3.3h-12.5v36.9ZM1871.3,3.3h-20.1v60.4h20.1c20.5,0,32.1-10.9,32.1-30.2s-11.5-30.2-32.1-30.2ZM1871.1,53h-7.6V13.9h7.6c13,0,19.3,6.4,19.3,19.5s-6.4,19.5-19.3,19.5ZM1207.2,3.4l-51.8,149.3h32.3l11.7-36.5h57.3l11.5,36.5h32.3L1248.7,3.4h-41.5ZM1207.8,89.8l3.1-9.9c6.1-19.3,11.7-39,16.8-58.3h.4c5,19.3,10.9,39,17,58.3l3.1,9.9h-40.5Z"/>
            </svg>
          </div>
        </header>
        <nav className="nav">
          <ul>
            <li>
              <button onClick={() => { setContent(about); setPanelOpen(true)}}>About</button>
            </li>
            <li>
              <a href="https://views.assemblageworld.com" title="Views" target="_blank" rel="noreferrer">Magazine</a>
            </li>
            <li>
              <button onClick={() => { setContent(contact); setPanelOpen(true)}}>Contact</button>
            </li>
          </ul>
        </nav>
        <section className={`main ${panelOpen ? 'is-under' : ''}`}>
          <span className="location">{hours}<span className="blink">:</span>{mins} – Los Angeles, CA</span>
          <h1 className="reveal-text">We amplify purposeful ideas through a unique marketing paradigm of storytelling content, visual presentation and business development.</h1>
          <div className="subscribe-form">
            <h2>Register for launch updates</h2>
            <form action="https://assemblageworld.us1.list-manage.com/subscribe/post?u=39a5ea5fdebb23b8c8445f779&amp;id=127dffddfb" method="post" id="mc-embedded-subscribe-form" name="mc-embedded-subscribe-form" className="validate" target="_blank" noValidate>
              <input type="email" name="EMAIL" className="required email" id="mce-EMAIL" placeholder="Email" required />
              <div id="mce-responses" className="clear">
                <div className="response" id="mce-error-response" style={{display: 'none'}}></div>
                <div className="response" id="mce-success-response" style={{display: 'none'}}></div>
              </div> 
              <div style={{position: 'absolute', left: -5000 + 'px'}} aria-hidden="true"><input type="text" name="b_39a5ea5fdebb23b8c8445f779_127dffddfb" tabIndex="-1" /></div>
              <div className="clear"><button type="submit" name="subscribe" id="mc-embedded-subscribe" className="button">Submit</button></div>
            </form>
          </div>
        </section>
      </div>
      <Panel
        close={closePanel}
        state={panelOpen}
        type={content} />
    </>
  )
}

export default App
